import React, { useEffect } from "react";
import Modal from "react-modal";

// Set app element for accessibility
Modal.setAppElement("#root");

const ModalWrapper = ({
  isOpen,
  onClose,
  children,
  title,
  size = "medium",
  hasPadding = true,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const getSizeClasses = () => {
    const sizes = {
      small: "w-fit",
      medium: "w-fit",
      large: "w-fit",
    };
    return sizes[size] || sizes.medium;
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-[2px] flex items-center justify-center z-50"
      className={`bg-white rounded-3xl outline-none ${hasPadding ? "p-6" : ""} ${getSizeClasses()} sm:mx-0 mx-2`}
    >
      <div className="modal-content">{children}</div>
    </Modal>
  );
};

export default ModalWrapper;
